/**
 * Normalize experience API JSON to inner payload shape (wrapped `{ data: { video } }`
 * vs flat). Single source of truth for dataAccess + publisher prefetch warm paths.
 */
import type { ExperiencePayload } from "@/types/experience";

type RawBody = ExperiencePayload & { data?: ExperiencePayload };

export function normalizeExperienceBody(
  raw: unknown,
): ExperiencePayload | null {
  if (!raw || typeof raw !== "object") {
    return null;
  }
  const body = raw as RawBody;
  if (
    body.data !== undefined &&
    typeof body.data === "object" &&
    body.data.video !== undefined
  ) {
    return body.data;
  }
  if (body.video !== undefined) {
    return body;
  }
  return body;
}
